import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 15l3 -3l-3 -3","key":"svg-0"}],["path",{"d":"M3 15l3 -3l-3 -3","key":"svg-1"}],["path",{"d":"M6 12l15 0","key":"svg-2"}]]

/**
 * IconArrowRightTail
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctcmlnaHQtdGFpbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggMTVsMyAtM2wtMyAtMyIgLz4KICA8cGF0aCBkPSJNMyAxNWwzIC0zbC0zIC0zIiAvPgogIDxwYXRoIGQ9Ik02IDEybDE1IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-right-tail
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowRightTail = createReactComponent('outline', 'arrow-right-tail', 'ArrowRightTail', __iconNode);

export default IconArrowRightTail;